import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/feature/Seo";
import Hero from "@/pages/home/components/Hero";
import Ticker from "@/pages/home/components/Ticker";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import CategorySection from "@/pages/home/components/CategorySection";
import RankingBoard from "@/pages/home/components/RankingBoard";
import StatsSection from "@/pages/home/components/StatsSection";
import FaqSection from "@/pages/home/components/FaqSection";
import ClosingCta from "@/pages/home/components/ClosingCta";
import { faqs } from "@/mocks/faqs";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "反差档案",
    alternateName: "网红反差前后对比观察站",
    url: "https://fancha-archive.example",
    description:
      "反差档案整理网红前后形象对比照，按同一位博主归档早期素人照与近期精修图，直观呈现网红反差变化有多大。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://fancha-archive.example/bang?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "反差档案",
    url: "https://fancha-archive.example",
    email: "hello@fancha-archive.example",
    description: "以公开信息整理为主的网红形象变化观察站，提供网红反差前后对比内容。",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  },
];

export default function Home() {
  return (
    <SiteLayout>
      <Seo
        title="网红反差官网 - 网红反差前后对比与网红反差变化有多大"
        description="反差档案整理网红前后形象对比照，按同一位博主收录早期素人照、公开露面与最近精修图，吃瓜考古一眼看清网红反差变化有多大。"
        keywords="网红反差,网红反差前后对比,网红反差变化有多大,网红反差形象对比"
        path="/"
        jsonLd={homeJsonLd}
      />
      <main>
        <Hero />
        <Ticker />
        <FeaturedSection />
        <CategorySection />
        <RankingBoard />
        <StatsSection />
        <FaqSection />
        <ClosingCta />
      </main>
    </SiteLayout>
  );
}